module.exports = __webpack_public_path__ + "static/img/ll06.5c278e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ll06.png
// module id = XXpt
// module chunks = 0